import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useApproveStepAccountConnection, useAuth } from 'src/hooks'

import { AppEvents, ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'

const useApproveConnection = () => {
  const [t] = useTranslation()
  const { mutateAsync } = useApproveStepAccountConnection()
  const [searchParams, setSearchParams] = useSearchParams()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    const token = searchParams.get('token')

    if (!isAuthenticated) {
      handleNavigate(ROUTES.LOGIN)
      const detail = { message: t('need-authenticate-message') }
      document.dispatchEvent(new CustomEvent(AppEvents.HTTP_ERROR, { detail }))
      return
    }

    if (!token) {
      handleNavigate(`/${ROUTES.ACCOUNTS}`)
      return
    }

    ;(async () => {
      const resp = await mutateAsync(token)

      if (!resp) {
        return handleNavigate(joinAbsRoute(ROUTES.ACCOUNTS))
      }

      handleNavigate(joinAbsRoute(ROUTES.ACCOUNTS, resp.accountId, ROUTES.STEPS))
    })()

    function handleNavigate(to: string) {
      setTimeout(() => {
        navigate(to)
      }, 1500)
    }
  }, [isAuthenticated, mutateAsync, navigate, queryClient, searchParams, setSearchParams, t])
}

export { useApproveConnection }
